declare global {
    interface Array<T> {
        orderBy(propertyExpression: (item: T) => number | string | Date): Array<T>;
        orderByDescending(propertyExpression: (item: T) => number | string | Date): Array<T>;
        splitByChunks<T>(chunkSize: number): Array<Array<T>>
    }
}

Array.prototype.splitByChunks = function (chunkSize: number): Array<Array<any>> {
    const source: Array<any> = this;
    const target = [];

    for (let i = 0, j = source.length; i < j; i += chunkSize) {        
        target.push(source.slice(i, i + chunkSize));
    }

    return target;
}

Array.prototype.orderBy = function (propertyExpression: (item: any) => any): Array<any> {
    const list: Array<any> = this;

    return list.sort((x, y) => {

        const a = propertyExpression(x);
        const b = propertyExpression(y);

        var objectA: any = a;
        var objectB: any = b;

        if (a && typeof a === "string") {
            objectA = a.toUpperCase();
        }

        if (b && typeof b === "string") {
            objectB = b.toUpperCase();
        }

        if (objectA < objectB) {
            return -1;
        }
        if (objectA > objectB) {
            return 1;
        }

        // names must be equal
        return 0;
    })
};

Array.prototype.orderByDescending = function (propertyExpression: (item: any) => any): Array<any> {
    const list: Array<any> = this;

    return list.sort((x, y) => {

        const a = propertyExpression(x);
        const b = propertyExpression(y);

        var objectA: any = a;
        var objectB: any = b;

        if (a && typeof a === "string") {
            objectA = a.toUpperCase();
        }

        if (b && typeof b === "string") {
            objectB = b.toUpperCase();
        }

        if (objectA < objectB) {
            return 1;
        }
        if (objectA > objectB) {
            return -1;
        }

        // names must be equal
        return 0;
    })
};

export { }; 